import React, {useState} from 'react';

function BannerConsentimiento() {
    //More details
    {/*function toggleContent() {
          const contenido = document.getElementById("content");
          const boton = document.querySelector(".read-more");
          const content = document.getElementById("costumize-content");
          content.style.display = "none";
          if (contenido.style.display === "none") {
            contenido.style.display = "block";
            boton.textContent = "Mostrar menos";
          } else {
            contenido.style.display = "none";
            boton.textContent = "Mostrar más";
          }
}*/}
    const [isVisibleDetails, setIsVisibleDetails] = useState(false);
    const toggleVisibilityDetails = () => {
        setIsVisibleDetails(!isVisibleDetails);
    };
    //Visible Banner
    {/*function costumizeContent() {
          const content = document.getElementById("costumize-content");
          const buttonmore = document.querySelector(".readcostumize-more");
            
          if (content.style.display === "none") {
            content.style.display = "block";
            buttonmore.textContent = "Mostrar menos";
          } else {
            content.style.display = "none";
            buttonmore.textContent = "Mostrar más";
          }
}*/}
    const [isVisibleBanner, setIsVisibleBanner] = useState(false);

    const toggleVisibilityBanner = () => {
        setIsVisibleBanner(!isVisibleBanner);
    };

    const buttonAcceptAll = document.getElementById('aceptall');
    const buttonRejectAll = document.getElementById('rejectall');
    const buttonCostimize = document.getElementById('costumize');
    const popupCookies = document.getElementById('cookiesModal');
    const backgroundCookies = document.getElementById('cookiesbanner');
    const savecookies = document.getElementById('save-custom');
    
    
    // Configura el estado inicial del banner de cookies
    window.addEventListener("DOMContentLoaded", () => {
        const banner = document.getElementById("cookiesbanner");
        // Función para aplicar los cambios de consentimiento en Google Consent Mode
        const setConsent = (preferences) => {
            window.gtag('consent', 'update', {
                'ad_user_data': preferences.userdata ? 'granted' : 'denied',
                'ad_personalization': preferences.personalization ? 'granted' : 'denied',
                'ad_storage': preferences.storage ? 'granted' : 'denied',
                'analytics_storage': preferences.analytics ? 'granted' : 'denied'
            });
            localStorage.setItem("cookieConsent", JSON.stringify(preferences));
            //document.getElementById("cookiesbanner").style.display = "none"; // Oculta el banner
            backgroundCookies.classList.remove('active');
            window.history.replaceState({}, document.title, window.location.pathname);  
        };
    
        // Carga las preferencias de consentimiento desde localStorage
        const getConsent = () => JSON.parse(localStorage.getItem("cookieConsent"));

        const consent = getConsent();
        if (consent) {
            setConsent(consent); // Aplica el consentimiento almacenado
        } else {
            //banner.style.display = "block"; // Muestra el banner si no hay consentimiento
            backgroundCookies.classList.add('active');
        }
    
        // Aceptar todas las cookies
        buttonAcceptAll.addEventListener("click", () => {
            setConsent({ userdata: true, personalization: true, storage: true, analytics: true});
        });
    
        // Rechazar todas las cookies
        buttonRejectAll.addEventListener("click", () => {
            setConsent({ userdata: false, personalization: false, storage: false, analytics: false });
        });
    
        // Guardar preferencias personalizadas
        savecookies.addEventListener("click", () => {
            /*true o false*/
            const analytics = document.getElementById("flexSwitchCheckReverse1").checked;
            const personalizations = document.getElementById("flexSwitchCheckReverse2").checked;
            
            if(personalizations && analytics == true){
                setConsent({ userdata: true, personalization: true, storage: true, analytics: true});
            }else if(personalizations && analytics == false){
                setConsent({ userdata: false, personalization: false, storage: false, analytics: false });
            }else{
                if(personalizations == true ){
                    setConsent({ userdata: true, personalization: true, storage: true, analytics: false});
                }
                if(analytics == true){
                    setConsent({ userdata: false, personalization: false, storage: false, analytics: true});
                }
            }
        });
  });
  



  return (
    <div>
        <div id="cookiesbanner" className="cookies" >
            <div className="row">
                <div className=" col-lg-7 col-md-6  col-sm-12" style={{color: 'white'}}>
                    <h3>Valoramos tu privacidad</h3>
                    <p style={{textAlign: 'justify'}}>Usamos cookies para mejorar tu experiencia de navegación y brindarte un servicio personalizado. 
                        Las cookies que se clasifican como necesarias se almacenan en tu navegador, ya que son esenciales 
                        para el funcionamiento de las funcionalidades básicas del sitio web. 
                    </p>
                    
                    <div id="content">
                        <p style={{textAlign: 'justify'}}>También utilizamos cookies de terceros que nos ayudan a analizar y comprender cómo utilizas este 
                            sitio web. Estas cookies se almacenarán en tu navegador solo con tu consentimiento. Tienes la opción de no 
                            aceptar estas cookies. Pero la exclusión voluntaria de algunas de estas cookies puede afectar tu 
                            experiencia de navegación.
                        </p>
                    </div>
                    <a style={{color: 'var(--amarillo)', textDecoration:'none'}} className="read-more" onClick={toggleVisibilityDetails}>Mostrar más</a>

                </div>
                <div className="col-lg-5 col-md-6 col-sm-12" style={{display: 'flex', justifyContent: 'space-evenly', alignItems: 'center'}}>
                    
                        <button id="costumize" type="button" data-bs-toggle="modal" data-bs-target="#cookiesModal">Personalizar</button>
                
                        <button id="rejectall">Rechazar </button>
                        {/**onClick={consentGrantedAdStorage()} */}
                        <button id="aceptall" >Aceptar</button>
                    
                </div>
            </div>
            
            
        </div>
    
        <div id="cookiesModal" className="modal fade" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true" style={{zIndex:'100000'}}>
            <div className="modal-dialog ">
                <div className="modal-content">
                <div className="modal-header">
                    <h5 className="modal-title" id="staticBackdropLabel">Configuración de Cookies</h5>
                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div className="modal-body" >
                    <p style={{textAlign: 'justify'}}>Este sitio web utiliza cookies y otras tecnologías de seguimiento para mejorar tu experiencia de navegación, analizar el tráfico y personalizar el contenido que te ofrecemos. 
                    </p>
                    
                    <div id="costumize-content" style={{display: 'none'}}>
                    <p style={{textAlign: 'justify'}}> 
                        Algunas cookies son necesarias para el funcionamiento básico del sitio y no pueden desactivarse. Otras cookies son opcionales y nos ayudan a comprender mejor cómo utilizas nuestro sitio y a ofrecerte anuncios que puedan ser de tu interés. Solo utilizamos estas cookies con tu consentimiento.
                        Puedes gestionar tus preferencias de cookies, aceptar todas o rechazarlas en cualquier momento. Para más detalles sobre el uso de tus datos y tus derechos, consulta nuestra<a href="./aviso-de-privacidad.html"> Aviso de Privacidad</a> y <a href="./politica-de-cookies.html"> Política de Cookies</a>.
                    </p>
                    </div>
                    <a style={{color: 'var(--amarillo)'}} className="readcostumize-more" onClick={toggleVisibilityBanner}>Mostrar más</a>
                    <div className="accordion" id="accordionExample">
                        <div className="accordion-item">
                            <div className="accordion-header" id="headingOne">
                                <div className="pt-3 pb-3" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                <div className="row" style={{alignItems: 'center'}}>
                                    <div className="col-md-7 col-8">
                                        <h6 style={{fontWeight: '700'}}><svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-plus" viewBox="0 0 16 16">
                                            <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"/>
                                        </svg>Cookies Necesarias</h6>
                                    </div>
                                    <div className="col-md-5 col-4">
                                        <h6 style={{fontweight: '700', color:' #009929'}}>Activadas por defecto</h6>
                                    </div>
                                </div>
                            </div>
                            </div>
                            <div id="collapseOne" className="accordion-collapse collapse" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                                <div className="accordion-body pt-0">
                                Estas cookies son esenciales para el funcionamiento básico del sitio y no almacenan información personal identificable. Se utilizan para funciones básicas, como seguridad, gestión de red y accesibilidad.

                                </div>
                            </div>
                        </div>
                        <div className="accordion-item pt-3 pb-3" style={{borderTop: '1px solid var(--secondary)', borderBottom: '1px solid var(--secondary)'}}>
                        <div className="accordion-header" id="headingTwo">
                            <div className="row" style={{alignItems: 'center'}}>
                                <div className="col-md-7 col-9">
                                    <div className=" collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                    <h6 style={{fontWeight: '700', marginBottom:'0px'}}><svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-plus" viewBox="0 0 16 16">
                                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"/>
                                    </svg>Cookies de Análisis</h6>
                                </div>
                                </div>
                                <div className="col-sm-5 col-3">
                                    <div className="form-check form-switch form-check-reverse">
                                        <input className="form-check-input" type="checkbox" id="flexSwitchCheckReverse1"/>
                                    </div>
                                </div>
                            </div>
                            
                            
                        </div>
                        <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                            <div className="accordion-body">
                            <h6>Estas cookies nos ayudan a comprender cómo los visitantes interactúan con el sitio web mediante la recopilación y generación de informes anónimos.</h6>
                            </div>
                        </div>
                        </div>
                        <div className="accordion-item pt-3 pb-3">
                        <div className="accordion-header" id="headingThree">
                            <div className="row">
                                <div className="col-sm-10 col-10">
                                    
                                    <div className=" collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                    <h6 style={{fontWeight: '700', marginBottom:'0px'}}><svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-plus" viewBox="0 0 16 16">
                                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"/>
                                    </svg>Cookies de Personalización y Publicidad</h6>
                                </div>
                                </div>
                                <div className="col-sm-2 col-2">
                                    <div className="form-check form-switch form-check-reverse">
                                        <input className="form-check-input" type="checkbox" id="flexSwitchCheckReverse2"></input>
                                    </div>
                                </div>
                            
                            </div>
                        </div>
                        <div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                            <div className="accordion-body">
                                Utilizamos estas cookies para ofrecerte contenido y anuncios personalizados según tus intereses y para medir la efectividad de nuestras campañas publicitarias.
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
                
                
                <div className="modal-footer">
                    <button type="button" data-bs-dismiss="modal" >Cerrar</button>
                    <button id="save-custom" data-bs-dismiss="modal" type="button" >Aceptar</button>
                </div>
                </div>
            </div>
        </div>
    </div>
  );
}

export default BannerConsentimiento; 
